// extracted by mini-css-extract-plugin
export default {"item":"styles_item__g5ere","item-tag-label":"styles_item-tag-label__9GftU","item-tag-ancestor":"styles_item-tag-ancestor__dRuvh"};